export default __webpack_public_path__ + "static/media/bank-id.44cf671e.svg";